import AccountCircleOutlinedIcon from "@mui/icons-material/AccountCircleOutlined";
import { Card, CardMedia, Grid, Typography } from "@mui/material";
import { uniq } from "lodash";
import moment from "moment";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import CustomButton from "../../../components/CustomButton";
import CustomCheckbox from "../../../components/CustomCheckbox";
import CustomModal from "../../../components/CustomModal/CustomModal";
import CustomTextField from "../../../components/CustomTextField";
import CustomSelect from "../../../components/Select/Select";
import {
  clinicRescheduleAppointment,
  getAppointmentsByVetIdAndDate,
  getAvailabilityByVetIdAndType,
} from "../../../redux/reducers/clinicSlice";
import { getVetHolidaysById } from "../../../redux/reducers/doctorSlice";
import { getClinicVets } from "../../../redux/reducers/vetSlice";
import { AppColors } from "../../../util/AppColors";
import { appointmentLaterList, appointmentList } from "../../../util/dropList";
import {
  getAllDatesFromArray,
  getAllSelectedSlots,
  getRequiredSlotList,
  getUpcoming60Dates,
} from "../../../util/function";

const cardSty = {
  borderRadius: 1,
  padding: 2,
  borderTopColor: AppColors.appPrimary,
};
const initTimeObj = { times: [], ids: [] };

const RealschuleReassign = ({
  modalVisible,
  onCloseModal,
  selectedPet,
  isInpatient = false,
  selectedItem,
  reAssign = false,
}) => {
  const dispatch = useDispatch();
  const [modOpen, setModOpen] = useState(false);
  const [bookValues, setBookValues] = useState({});
  const [errors, setErrors] = useState({});
  const [selectTimeIdError, setSelectTimeIdError] = useState(false);
  const [holidayDates, setHolidayDates] = useState([]);
  const [timeObject, setTimeObject] = useState(initTimeObj);
  const clinicVets = useSelector((state) => state?.vet?.vets?.vets);
  const holidays = useSelector((state) => state?.doctor?.holidays);
  const clinicHolidays = useSelector((state) => state?.clinic?.holidays);
  const { vetAvailability, vetBookedApnts, userDetails } = useSelector(
    (state) => state?.clinic,
  );
  const user = localStorage.getItem("user");
  const profile = JSON.parse(user);
  const apntId = selectedItem?.appointmentId;

  useEffect(() => {
    dispatch(getClinicVets());
  }, []);

  useEffect(() => {
    setModOpen(modalVisible);
  }, [modalVisible]);

  useEffect(() => {
    if (
      reAssign ||
      !bookValues?.vetName?.value ||
      !bookValues?.date ||
      !bookValues?.appointmentOption
    ) {
      return;
    }
    if (bookValues?.appointmentOption === "Later") {
      dispatch(getVetHolidaysById(bookValues?.vetName?.value));
      dispatch(
        getAvailabilityByVetIdAndType({
          vetId: bookValues?.vetName?.value,
          type: bookValues?.consultationMode,
        }),
      );
      dispatch(
        getAppointmentsByVetIdAndDate({
          vetId: bookValues?.vetName?.value,
          date: moment(new Date(bookValues?.date)).format("YYYY-MM-DD"),
          clinicId: profile?.id,
        }),
      );
    }
  }, [
    bookValues?.vetName?.value,
    bookValues?.date,
    bookValues?.appointmentOption,
    bookValues?.consultationMode,
  ]);

  useEffect(() => {
    if (selectedItem) {
      setBookValues({
        ...selectedItem,
        appointmentTime:
          selectedItem?.appointmentTime ?? selectedItem?.appointmentStartTime,
        appointmentId: selectedItem?.appointmentId,
        appointmentDate: selectedItem?.appointmentDate,
        bookingType: "Walk-in",
        consultationMode: selectedItem?.appointmentType ?? "Physical",
        serviceType: isInpatient ? "Surgery" : selectedItem?.serviceType,
        reason: Array.isArray(selectedItem?.reason)
          ? selectedItem?.reason?.join(", ")
          : "",
        vetName:
          getVetList()?.find((vet) => vet?.value === selectedItem?.doctorId) ??
          null,
        appointmentOption: selectedItem?.immediate ? "Immediate" : "Later",
        date: new Date(selectedItem?.appointmentDate ?? new Date()),
      });
    }
  }, [selectedItem]);

  useEffect(() => {
    getHolidayDateList();
  }, [holidays, clinicHolidays, vetAvailability]);

  const getHolidayDateList = () => {
    if (
      (holidays?.length === 0 || !holidays) &&
      (clinicHolidays?.length === 0 || !clinicHolidays) &&
      vetAvailability?.every((li) => li?.status)
    ) {
      return setHolidayDates([]);
    }
    const vetDates = getAllDatesFromArray(holidays) ?? [];
    const cliHolidays =
      clinicHolidays?.map((hl) => {
        return hl?.date;
      }) ?? [];
    const unAvilableDates =
      vetAvailability?.length > 0 ? getUpcoming60Dates(vetAvailability) : [];
    const mergedArray = vetDates?.concat(cliHolidays, unAvilableDates);
    setHolidayDates(uniq(mergedArray));
  };

  const getVetList = () => {
    return clinicVets
      ?.filter((vl) => {
        if (vl?.userType?.find((ut) => ut?.name === "ROLE_DOCTOR")) {
          return vl;
        }
      })
      ?.map((vet) => {
        return { name: vet?.name, value: vet?.doctorId, id: vet?.doctorId };
      });
  };

  const onCloseMod = () => {
    onCloseModal(false);
    setModOpen(false);
  };

  const handleChangeBookValue = (key, value) => {
    const reqValue =
      typeof value === "object"
        ? typeof value?.value === "number"
          ? value?.value?.toString()
          : value?.value
        : value;
    if (key === "appointmentOption" && value === "Immediate") {
      setSelectTimeIdError(false);
    }
    setBookValues({ ...bookValues, [key]: value });
    setErrors({
      ...errors,
      [key]: reqValue?.length > 0 ? false : "Required Field",
    });
  };

  const handleSelectectedTimeIds = (time) => {
    const reqTimeIds = [...timeObject?.times, time];
    let ids = [];
    const reqList = {
      times: reqTimeIds?.length > 2 ? [time] : reqTimeIds,
    };
    if (reqList?.times?.length === 2) {
      ids = getAllSelectedSlots(
        getRequiredSlotList({
          availability: vetAvailability,
          date: bookValues?.date,
          bookedApnts: vetBookedApnts,
        }),
        reqTimeIds,
      );
      reqList.ids = ids;
    } else {
      ids.push(time);
      reqList.ids = ids;
    }
    setTimeObject(reqList);
    setSelectTimeIdError(reqTimeIds?.length === 2 ? false : true);
  };

  const validateFields = () => {
    const newErrors = {};
    if (!bookValues?.vetName?.value)
      newErrors.vetName = "This field is required";
    if (!bookValues?.appointmentOption)
      newErrors.appointmentOption = "Appointment Type is required";
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSave = () => {
    if (!validateFields() || selectTimeIdError) return;
    // dispatch(showLoader());
    const data = {
      appointmentDate: moment(new Date(bookValues?.date)).format("YYYY-MM-DD"),
      doctorId: bookValues?.vetName?.value,
      appointmentStartTime: timeObject?.ids?.[0]?.startTime,
      appointmentEndTime:
        timeObject?.ids?.[timeObject?.ids?.length - 1]?.endTime,
    };
    if (bookValues?.assignedUsers?.length > 0) {
      data.assignedUsers = bookValues?.assignedUsers?.map((li) => li?.value);
    }
    dispatch(clinicRescheduleAppointment({ appointmentId: apntId, data })).then(
      (res) => {
        if (res?.payload) {
          onCloseModal();
          onCloseMod();
        }
      },
    );
  };

  const getAllClinicUserListWoSelectedVet = (vetId) => {
    if (!vetId) return [];
    const reqVetList =
      clinicVets
        ?.filter(
          (vl) =>
            vl?.status === "Y" &&
            vl?.doctorId !== vetId &&
            vl?.userType?.some(
              (ut) => ut?.name === "ROLE_DOCTOR" || ut?.name === "ROLE_GROOMER",
            ),
        )
        ?.map((vet) => {
          return { name: vet?.name, value: vet?.doctorId, id: vet?.doctorId };
        }) ?? [];
    return reqVetList;
  };

  return (
    <>
      <CustomModal
        open={modOpen}
        onClose={onCloseMod}
        header="Reschedule / Reassign"
        rightModal
        modalWidth={30}
        headerBold
      >
        <Grid container spacing={1} className="ph20 scroll-80vh">
          <Grid item xs={12}>
            <Card sx={cardSty} className="CustomCard-back-appointment">
              <div className="maint">
                <div className="flex-row">
                  <Grid item xs={3}>
                    <div className="flex-center">
                      {selectedItem?.petImage ? (
                        <CardMedia
                          image={selectedItem?.petImage}
                          className="CustomCard-img3-bill"
                        />
                      ) : (
                        <div className="flex-center h50img">
                          <Typography className="font-bold fs30 white-color capitalize">
                            {selectedItem?.petName?.[0]}
                          </Typography>
                        </div>
                      )}
                    </div>
                  </Grid>
                  <div className="flex-row">
                    <div className="flex-start">
                      <div className="flex-column">
                        <div className="flex-row">
                          <div className="mb10 txt-semi-bold black fs14 capitalize">
                            {selectedItem?.petName}
                          </div>
                          <Typography
                            className={`ml5 text capitalize ${
                              selectedItem?.gender === "male"
                                ? "card-blue-color"
                                : "card-rose-color"
                            }`}
                          >
                            {`(${selectedItem?.gender})`}
                          </Typography>
                        </div>
                        <Typography className="mb10 txt-regular card-gray-color fs12">
                          {selectedItem?.breed}
                        </Typography>
                      </div>
                    </div>
                  </div>
                  <div></div>
                </div>
                <div>
                  <div className="flex-row parentcontainer mt10">
                    <div className="flex-row iconcontainer">
                      <AccountCircleOutlinedIcon
                        sx={{ width: 25, height: 25 }}
                      />
                      <div className="txt-semi-bold fs14 capitalize">
                        {selectedItem?.userName}
                      </div>
                    </div>
                    <div className="meeting-doctor">
                      {moment(selectedItem?.dob).fromNow()} ({selectedItem?.dob}
                      )
                    </div>
                  </div>
                </div>
              </div>
            </Card>
          </Grid>
          <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
            <div className="txt-semi-bold fs14 light-grey">
              Booking Type <span className="red-color">*</span>
            </div>
            <CustomSelect value={bookValues?.bookingType} selectFixed />
          </Grid>
          <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
            <div className="txt-semi-bold fs14 light-grey">
              Consultation Mode <span className="red-color">*</span>
            </div>
            <CustomSelect value={bookValues?.consultationMode} selectFixed />
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
            <div className="txt-semi-bold fs14 light-grey">
              Service Type <span className="red-color">*</span>
            </div>
            <CustomSelect value={bookValues?.serviceType} selectFixed />
          </Grid>

          <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
            <div className="txt-semi-bold fs14 light-grey">
              Reason for visit <span className="red-color">*</span>
            </div>
            <CustomSelect value={bookValues?.reason} selectFixed />
          </Grid>

          <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
            <div className="txt-semi-bold fs14 light-grey mb10">
              Vet Name <span className="red-color">*</span>
            </div>

            <CustomSelect
              list={getVetList()}
              handleChange={(e, value) =>
                handleChangeBookValue("vetName", value)
              }
              name="vetName"
              search
              value={bookValues?.vetName}
              error={!!errors?.vetName}
              helperText={errors?.vetName}
              // label="Vet Name *"
            />
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
            <div className="txt-semi-bold fs14 light-grey mb10">
              Assigned Users
            </div>

            <CustomSelect
              list={getAllClinicUserListWoSelectedVet(
                bookValues?.vetName?.value,
              )}
              value={bookValues?.assignedUsers ?? []}
              name="assignedUsers"
              handleChange={(e) => {
                handleChangeBookValue("assignedUsers", e?.target?.value);
              }}
              multiSelectSearchCheck
            />
          </Grid>
          {reAssign ? null : (
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <div className="txt-semi-bold fs14 light-grey">
                Appointment Time:{" "}
                {moment(
                  new Date(selectedItem?.appointmentdateTime ?? new Date()),
                ).format("DD MMM YYYY HH:mm")}
              </div>
            </Grid>
          )}
          <Grid
            item
            xs={12}
            sm={12}
            md={12}
            lg={12}
            xl={12}
            className="mbminus"
          >
            <div className="flex-row">
              <div className="txt-semi-bold fs14 light-grey mt10">
                Appointment <span className="red-color">*</span> :
              </div>
              <div className="ml5">
                <CustomCheckbox
                  radio
                  value={bookValues?.appointmentOption}
                  onChange={(e) =>
                    handleChangeBookValue("appointmentOption", e?.target?.value)
                  }
                  radios={reAssign ? appointmentList : appointmentLaterList}
                  disabled={reAssign}
                  defaultValue={bookValues?.appointmentOption}
                />
              </div>
            </div>

            {!!errors?.appointmentOption && (
              <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                <Typography color="error" className="mt5 fs14">
                  Appointment is Required
                </Typography>
              </Grid>
            )}
          </Grid>

          {!reAssign && bookValues?.appointmentOption === "Later" && (
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <div className="txt-mont fs14 ">
                Date <span className="red-color">*</span>
              </div>
              <div className="mb20">
                <CustomTextField
                  name="date"
                  value={bookValues?.date}
                  labelTop
                  fullWidth
                  handleChange={(e) =>
                    handleChangeBookValue("date", e?.target?.value)
                  }
                  mobileDateWithBatch
                  markDateList={holidayDates ?? []}
                />
              </div>
            </Grid>
          )}

          {!reAssign &&
            bookValues?.appointmentOption === "Later" &&
            bookValues?.date &&
            getRequiredSlotList({
              availability: vetAvailability,
              date: bookValues?.date,
              bookedApnts: vetBookedApnts,
              holidays,
            })?.length > 0 &&
            getRequiredSlotList({
              availability: vetAvailability,
              date: bookValues?.date,
              bookedApnts: vetBookedApnts,
              holidays,
            })?.map((item, i) => {
              return (
                <div
                  key={i}
                  onClick={() => handleSelectectedTimeIds(item)}
                  className={
                    timeObject?.ids?.find(
                      (id) => id?.startTime === item?.startTime,
                    )
                      ? "bgContainerSelected cursor"
                      : "bgContainerUnselected cursor"
                  }
                >
                  {item?.startTime}
                </div>
              );
            })}

          {selectTimeIdError && (
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <Typography color="error" className="mt5 fs14">
                Time is Required
              </Typography>
            </Grid>
          )}
        </Grid>
        <div className="flex1-end mt20 pr20">
          <div>
            <CustomButton text="Save" onClick={handleSave} smallBtn />
          </div>
        </div>
      </CustomModal>
    </>
  );
};

export default RealschuleReassign;
